interface Props {
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  min?: number;
}

const QtyStepper = ({ value, onIncrement, onDecrement, min = 1 }: Props) => (
  <div className="h-[37px] w-[91px] rounded-[6px] border bg-white flex items-center justify-between px-3" style={{ borderColor: "#F15A29" }} >
    <button type="button" aria-label="Decrease" onClick={onDecrement} disabled={value <= min} className="font-outfit font-semibold text-[14px] bg-transparent border-0 leading-none disabled:opacity-50" style={{ color: "#F15A29" }}>
      −
    </button>
    <span className="font-sansation font-bold text-[16px]" style={{ color: "#F15A29" }}  >
      {value}
    </span>
    <button type="button" aria-label="Increase" onClick={onIncrement} className="font-outfit font-semibold text-[14px] bg-transparent border-0 leading-none" style={{ color: "#F15A29" }} >
      +
    </button>
  </div>
);

export default QtyStepper;
